import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';

import NotableEvent from '../../components/NotableEvent';
import Loader from '../../components/Loader';
import Button from '../../components/Button';
import Header from '../../components/Header';
import PageTitle from '../../components/PageTitle';
import { messages as notificationMessages } from '../../components/RepVisitsNotificationsFrame';
import './styles.css';

const messages = defineMessages({
  noNotifications: {
    id: 'notifications.hsAvailable.noNotifications',
    defaultMessage: 'You currently have no notifications.',
  },
  showMore: {
    id: 'notifications.hsAvailable.showMore',
    defaultMessage: 'Show More',
  },
});

class RepVisitsNotificationsHSAvailable extends React.PureComponent {
  static propTypes = {
    viewer: PropTypes.object,
    loadMore: PropTypes.func.isRequired,
    displaySidebarComponent: PropTypes.func.isRequired,
    closeSidebar: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  loadMore = () => {
    this.setState({ loading: true });
    this.props.loadMore('viewer.repVisitsNotableEvents').then(() => this.setState({ loading: false }));
  }

  render() {
    const { viewer, displaySidebarComponent, closeSidebar } = this.props;
    const { loading } = this.state;
    const events = viewer.repVisitsNotableEvents.edges;
    const { hasNextPage } = viewer.repVisitsNotableEvents.pageInfo;

    return (
      <div styleName="container">
        <PageTitle subTitle="High Schools Now Available" title="RepVisits Notifications" category="Intersect" />
        <Header as="h2" styleName="section-title" id="right-side-heading">
          <FormattedMessage {...notificationMessages.hsavailable} />
        </Header>
        {
          events.length === 0 ? (
            <div id="no-notifications-msg" styleName="no-notifications-message">
              <FormattedMessage {...messages.noNotifications} />
            </div>
          ): (
            <ul styleName="ul-padding">
              {events.map((event) => (
                <NotableEvent
                  event={event.node}
                  displaySidebarComponent={displaySidebarComponent}
                  closeSidebar={closeSidebar}
                  key={event.node.id}
                />
              ))}
              {hasNextPage && (
              <div styleName="show-more-container">
                <Loader inline active={loading} />
                {!loading && (
                <Button basic size="small" id="show-more-link" onClick={this.loadMore}>
                  <FormattedMessage {...messages.showMore} />
                </Button>
                )}
              </div>
              )}
            </ul>
          )
}
      </div>
    );
  }
}

export default RepVisitsNotificationsHSAvailable;
